export default (state) => ({
  ...state.apps.meta,
  total: Number(state.apps.meta.total),
  pages: Number(state.apps.meta.pages),
})
